import { Component, Input, Output, EventEmitter } from "@angular/core";
import { GraphicsInfoTextAlign } from "../../../../domain/graphics-info";
import { Font } from "../../../../domain/font";
import { UserService } from "../../../../domain/user-service";

@Component({
  selector: "icn-graphics-text-font",
  templateUrl: "./text-font.component.html",
  styleUrls: ["./text-font.component.scss"],
})
export class GraphicsTextFontComponent {
  fonts: Font[];
  textAlign = {
    Left: GraphicsInfoTextAlign.Left,
    Center: GraphicsInfoTextAlign.Center,
    Right: GraphicsInfoTextAlign.Right,
  };

  constructor(userService: UserService) {
    this.fonts = userService.getCurrentUser().fonts;
  }

  @Input()
  fontId: number;

  @Input()
  size: number;

  @Input()
  color: string;

  @Input()
  align: GraphicsInfoTextAlign;

  @Input()
  shrinkToFit: boolean;

  @Output()
  fontIdChange = new EventEmitter<number>();

  @Output()
  sizeChange = new EventEmitter<number>();

  @Output()
  colorChange = new EventEmitter<number>();

  @Output()
  alignChange = new EventEmitter<number>();

  @Output()
  shrinkToFitChange = new EventEmitter<boolean>();

  onFontIdChange(val) {
    this.fontId = val;
    this.fontIdChange.emit(val);
  }

  onSizeChange(val) {
    this.size = val;
    this.sizeChange.emit(val);
  }

  onColorChange(val) {
    this.color = val;
    this.colorChange.emit(val);
  }

  onAlignChange(val) {
    this.align = val;
    this.alignChange.emit(val);
  }
  onShrinkToFitChange() {
    this.shrinkToFit = !this.shrinkToFit;
    this.shrinkToFitChange.emit(this.shrinkToFit);
  }
}
